import {
    DEFAULT_ROWS_PER_PAGE,
    REPORT_ACTIVITY_QUESTION_TABLE_HEADERS,
} from "../../utils/constants";

import classes from "./Report.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import React, {useEffect, useMemo, useState} from "react";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";

import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";

import YuJaButton from "../../components/standardization/YuJaButton";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import styles from "../ManagePollsPage/ManagePolls.module.css";
import {Table} from "react-bootstrap";
import NormalPagination from "../../components/pagination/NormalPagination";
import {getQuestionWeightage, stripHTMLTags} from "../../utils/helpers";
import {questionCodeToSVG} from "../../utils/questionUtils";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import { useTranslation } from "react-i18next";

const getColumns = (t) => [
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name, width: 120},
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TITLE.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TITLE.name, width: 400 },
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TYPES.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TYPES.name, width: 150 },
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.WEIGHTAGE.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.WEIGHTAGE.name, width: 150 },
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.FINISHED_COUNT.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.FINISHED_COUNT.name, width: 120 },
    { Header: t(REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.INCOMPLETE_COUNT.labelKey), accessor: REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.INCOMPLETE_COUNT.name, width: 120 },
];

export default function TabQuestions({data, setData}) {
    const { t } = useTranslation();
    const columns = useMemo(() => getColumns(t), [t]);
    const [keyword, setKeyword] = useState();
    const [pageIdx, setPageIdx] = useState(0);
    const [filter, setFilter] = useState({});
    const [sortedBy, setSortedBy] = useState("");



    const clickSearch = () => {
        setFilter({keyword});
        setPageIdx(0);
    }

    useEffect(() => {
        setGlobalFilter(filter);
    }, [data, filter]);

    const filterCustomize = (rows, _, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.queTitle && values.queTitle.toLowerCase().indexOf(filteredKeyword.toLowerCase()) > -1) {
                return true;
            }

            return false;
        });
    };



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize},
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: DEFAULT_ROWS_PER_PAGE },
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);


    return (
        <>
            <div className={classes.tableSearchBox}>
                <YuJaTextBox
                    label={t("accessibility.searchPollTextbox")}
                    containerStyle={{fontSize: 15, marginLeft: 10, width: "70%"}}
                    placeholder={t("report.activityTableSearchPlaceholder")}
                    onChange={e => setKeyword(e.target.value)}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                />
                <YuJaButton onClick={clickSearch}>
                    <div style={{fontSize: 14, lineHeight: 1.6,}}>{t("common.search")}</div>
                </YuJaButton>
            </div>
            <div className={styles.tableWrapper}>
                <Table hover {...getTableProps()} >
                    <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, idx) => {
                                if (
                                    [
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name,
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TITLE.name,
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TYPES.name,
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.WEIGHTAGE.name,
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.FINISHED_COUNT.name,
                                        REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.INCOMPLETE_COUNT.name
                                    ].includes(column.id)
                                ) {
                                    return (
                                        <TableSortHeaderNew
                                            key={idx}
                                            data={data}
                                            setData={setData}
                                            sortedBy={sortedBy}
                                            setSortedBy={setSortedBy}
                                            propertyName={column.id}
                                            getProperty={(item) => item[column.id].toString()}
                                            label={column.Header}
                                            {...{
                                                // ...column.getHeaderProps(),
                                                key: column.id,
                                                style: {
                                                    width: column.width,
                                                    textAlign: 'left',
                                                    backgroundClip: "padding-box",

                                                }
                                            }}
                                        >
                                                <span
                                                    className={column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name
                                                        ? classes.firstCell : classes.tableCell}
                                                >
                                                    {column.Header}
                                                </span>
                                        </TableSortHeaderNew>
                                    );
                                } else {
                                    return (
                                        <th
                                            key={idx}
                                            {...column.getHeaderProps({
                                                style: {
                                                    width: column.width,
                                                    textAlign: column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.ACTION.name ? 'center' : 'left'
                                                }
                                            })}
                                        >
                                                <span className={ classes.tableCell}>
                                                    {column.Header}
                                                </span>
                                        </th>
                                    );
                                }
                            })}
                            {/*{headerGroup.headers.map(column => (*/}
                            {/*    <th*/}
                            {/*        {...column.getHeaderProps({*/}
                            {/*            style: {*/}
                            {/*                width: column.width,*/}
                            {/*                textAlign: column.render('Header') === ACTION_HEADER ? 'center' : 'left'*/}
                            {/*            }*/}
                            {/*        })}*/}
                            {/*    >*/}
                            {/*        <span className={column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name ? classes.firstCell : classes.tableCell}>*/}
                            {/*            {column.render('Header')}*/}
                            {/*            {checkDisplayDownArrow(column.render('Header')) &&*/}
                            {/*                <SortDown*/}
                            {/*                    tabIndex={0}*/}
                            {/*                    role={TEXTBOX}*/}
                            {/*                    aria-label={column.render('Header') + "descending order"}*/}
                            {/*                    style={{width: "15px", cursor: "pointer", marginLeft: "10px"}}*/}
                            {/*                    onClick={() => handleSort(column.render('Header'))}*/}
                            {/*                />*/}
                            {/*            }*/}

                            {/*            {checkDisplayUpArrow(column.render('Header')) &&*/}
                            {/*                <SortUp*/}
                            {/*                    tabIndex={0}*/}
                            {/*                    role={TEXTBOX}*/}
                            {/*                    aria-label={column.render('Header') + "ascending order"}*/}
                            {/*                    style={{width: "15px", cursor: "pointer", marginLeft: "10px"}}*/}
                            {/*                    onClick={() => handleSort(column.render('Header'))}*/}
                            {/*                />*/}
                            {/*            }*/}

                            {/*            {checkDisplayGreyArrow(column.render('Header')) &&*/}
                            {/*                <SortGrey*/}
                            {/*                    role={TEXTBOX}*/}
                            {/*                    tabIndex={0}*/}
                            {/*                    aria-label={column.render('Header') + "ascending order"}*/}
                            {/*                    style={{width: "15px", cursor: "pointer", marginLeft: "10px"}}*/}
                            {/*                    onClick={() => handleSort(column.render('Header'))}*/}
                            {/*                />*/}

                            {/*            }*/}
                            {/*        </span>*/}
                            {/*    </th>*/}
                            {/*))}*/}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page && page.length !== 0 &&
                        page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell, index) => {
                                        if (cell.column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TYPES.name) {
                                            return (
                                                <td>
                                                    <div style={{display: "flex", alignItems: "center", gap: 10}}>
                                                        {questionCodeToSVG(cell.value, false)}
                                                    </div>
                                                </td>
                                            );
                                        } else if (cell.column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.WEIGHTAGE.name) {
                                            return (
                                                <td>
                                                    <div
                                                        className={cell.column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name ? classes.firstCell : classes.tableCell}>
                                                        {getQuestionWeightage(row.original)}
                                                    </div>
                                                </td>
                                            );
                                        } else {
                                            return (
                                                <td>
                                                    <div
                                                        className={cell.column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.SERIAL_NO.name ? classes.firstCell : classes.tableCell}>
                                                        {cell.column.id === REPORT_ACTIVITY_QUESTION_TABLE_HEADERS.TITLE.name ? stripHTMLTags(cell.value) : cell.value}
                                                    </div>
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            );
                        })
                    }


                    {(!page || page.length === 0) &&
                        <tr>
                            <td colSpan="5" className={styles.noData} style={{boxShadow: "none"}}>
                                <div
                                    style={{
                                        justifyContent: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 5,
                                        padding: 20
                                    }}
                                >
                                    <NoResultIllustration/>
                                    <div style={{
                                        fontSize: "18px",
                                        marginTop: "10px",
                                        fontWeight: 600
                                    }}> {t("course.noResultsFound")} </div>
                                </div>
                            </td>
                        </tr>

                    }
                    </tbody>
                </Table>
            </div>

            {page && pageCount > 1 &&
                <div style={{flex: 1, display: "flex", alignItems: "flex-end"}}>
                    <NormalPagination
                        pageCount={pageCount}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        gotoPage={gotoPage}
                        paddingTop="0px"
                    />
                </div>
            }
        </>
    );
}